import styled from '@emotion/styled'
import React, { useState, useEffect } from 'react'
import { withAttrs } from '../../utils'
import Link from '../shared/link'
import useGalleryNavigation from './hooks/use-gallery-nav'
import { createGroupId } from './helpers'
import SubgroupMenu from './subgroup-menu'

const Container = styled.nav`
  background-color: ${p => p.theme.colors.white};
  box-shadow: ${p => p.theme.shadows.default};
`

const GroupLink = styled(withAttrs(Link, { variant: 'nav' }))`
  ${p =>
    p.partiallyActive &&
    `
    color: ${p => p.theme.colors.black[0]};
    font-weight: 700;
  `}
`

const MenuItemOuter = styled.div`
  :not(:last-of-type) {
    border-bottom: 1px solid ${p => p.theme.colors.gray[3]};
  }
`

const MenuItemInner = styled.div`
  position: relative;
  padding: ${p =>
    p.expanded
      ? `${p.theme.space[6]} ${p.theme.space[6]} ${p.theme.space[3]} ${p.theme.space[6]}`
      : p.theme.space[6]};
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    width: 25px;
    height: 25px;
    background: linear-gradient(#000, #000),
      ${p => !p.expanded && 'linear-gradient(#000, #000),'} #fff;
    background-position: center;
    background-size: 50% 1px, 1px 50%;
    background-repeat: no-repeat;
    ${p =>
      p.expanded &&
      `
        transform: translateY(-25%);    
    `}
  }
`

const MenuItemPlain = styled(GroupLink)`
  display: block;
  padding: ${p => p.theme.space[6]};

  &:not(:last-child) {
    border-bottom: 1px solid ${p => p.theme.colors.gray[3]};
  }
`

const MenuItem = ({ active, group, otherGroupActive }) => {
  const [expanded, setExpanded] = useState(active)

  useEffect(() => setExpanded(active), [otherGroupActive, active])

  const toggleExpanded = () => setExpanded(prevExpanded => !prevExpanded)
  const { createPath } = useGalleryNavigation()
  const firstSubgroup = group.subgroups[0]

  if (!firstSubgroup.name) {
    return (
      <MenuItemPlain
        to={createPath(group.name)}
        state={{ noScroll: true }}
        partiallyActive={active}
      >
        {group.name}
      </MenuItemPlain>
    )
  }

  return (
    <MenuItemOuter>
      <MenuItemInner expanded={expanded} onClick={toggleExpanded}>
        <GroupLink
          to={createPath(group.name, firstSubgroup.name)}
          state={{ noScroll: true }}
          partiallyActive={active}
        >
          {group.name}
        </GroupLink>
      </MenuItemInner>

      {expanded && <SubgroupMenu group={group} />}
    </MenuItemOuter>
  )
}

const GroupMenu = ({ className, groups, activeGroupId }) => (
  <Container className={className}>
    {groups.map(g => {
      const groupId = createGroupId(g.name)
      return (
        <MenuItem
          key={groupId}
          active={groupId === activeGroupId}
          otherGroupActive={activeGroupId}
          group={g}
        />
      )
    })}
  </Container>
)

export default GroupMenu
